exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".samples_XeGb3 {\n    text-align: center;\n}\n.signatureContainer_2UFwA {\n    padding-top: 10px;\n}\n\n.signatureEnrollment_lnzYp {\n    width: 100%;\n    text-align: center;\n}\n\n.signatureEnrollment_lnzYp td {\n    vertical-align: bottom;\n}\n\n.termsInputWrap_oRPNe {\n    /* display: inline-block;\n    width: 150px; */\n    padding: 0 5px;\n}\n\n.certify_2f9kQ {\n    text-align: center;\n}\n\n.divition_3YY-- {\n    margin: 0;\n    border-top: 3px solid #1e1e1e;\n}\n\n.gapSection3_D1ubm {\n    height: 30px;\n}\n", ""]);

// exports
exports.locals = {
	"samples": "samples_XeGb3",
	"signatureContainer": "signatureContainer_2UFwA",
	"signatureEnrollment": "signatureEnrollment_lnzYp",
	"termsInputWrap": "termsInputWrap_oRPNe",
	"certify": "certify_2f9kQ",
	"divition": "divition_3YY--",
	"gapSection3": "gapSection3_D1ubm"
};